// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RZYx","col":"styles_col__1YMJK"};